import {
    AppBar,
    Avatar,
    Box,
    Button,
    Container,
    Divider,
    Drawer,
    IconButton,
    Menu,
    MenuItem,
    Toolbar,
    Tooltip,
    Typography
} from '@mui/material';
import React, { memo, useCallback, useState } from 'react';
import { NavLink } from 'react-router-dom';
import '../../styles/HeaderStyles.css';
import MenuIcon from '@mui/icons-material/Menu';
import KKLogo from '../../assets/images/kk-logo.png';
import TitoLogo from '../../assets/images/tito-logo.png';
import { useDispatch, useSelector } from 'react-redux';
import { saveUserData } from '../../redux/slices/userSlice';

const Header = () => {
    const dispatch = useDispatch();
    let { user } = useSelector((state) => state?.user);

    const [mobileOpen, setMobileOpen] = useState(false);
    const [anchorElUser, setAnchorElUser] = React.useState(null);

    const handleDrawerToggle = () => {
        setMobileOpen((pre) => !pre);
    };

    const handleOpenUserMenu = useCallback((event) => {
        setAnchorElUser(event.currentTarget);
    }, []);

    const handleCloseUserMenu = useCallback(() => {
        setAnchorElUser(null);
    }, []);

    const handleLogout = () => {
        localStorage.clear();
        dispatch(saveUserData(null));
        window.location.replace('/');
    };

    const drawer = (
        <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <img src={KKLogo} alt="KK Foods Logo" style={{ height: 70, marginTop: 10, marginBottom: 10 }} />
                <img src={TitoLogo} alt="KK Foods Logo" style={{ height: 70, marginTop: 10, marginBottom: 10 }} />
            </Box>

            <Divider />

            <ul className="mobile-navigation">
                {user?.role === 'admin' || user?.role === 'super-admin' ? (
                    <>
                        <li>
                            <NavLink activeClassName="active" to="/">
                                Reps
                            </NavLink>
                        </li>

                        <li>
                            <NavLink to="/customers">Customers</NavLink>
                        </li>

                        <li>
                            <NavLink to="/products">Products</NavLink>
                        </li>

                        <li>
                            <NavLink to="/orders">Orders</NavLink>
                        </li>

                        <li>
                            <NavLink to="/order-items">Order Items</NavLink>
                        </li>

                        <li>
                            <NavLink to="/dispatched-items">Dispatched Items</NavLink>
                        </li>

                        <li>
                            <NavLink to="/banks">Banks</NavLink>
                        </li>

                        <li>
                            <NavLink to="/vendors">Vendors</NavLink>
                        </li>

                        <li>
                            <NavLink to="/goods">Goods</NavLink>
                        </li>

                        <li>
                            <NavLink to="/payments">Payments</NavLink>
                        </li>
                    </>
                ) : user.role === 'account' ? (
                    <>
                        <li>
                            <NavLink to="/a-banks">Banks</NavLink>
                        </li>

                        <li>
                            <NavLink to="/a-vendors">Vendors</NavLink>
                        </li>

                        <li>
                            <NavLink to="/a-payments">Payments</NavLink>
                        </li>
                    </>
                ) : user.role === 'dispatch' ? (
                    <>
                        <li>
                            <NavLink activeClassName="active" to="/d-reps">
                                Reps
                            </NavLink>
                        </li>

                        <li>
                            <NavLink to="/d-customers">Customers</NavLink>
                        </li>

                        <li>
                            <NavLink to="/d-products">Products</NavLink>
                        </li>

                        <li>
                            <NavLink to="/d-orders">Orders</NavLink>
                        </li>

                        <li>
                            <NavLink to="/d-order-items">Order Items</NavLink>
                        </li>

                        <li>
                            <NavLink to="/d-dispatched-items">Dispatched Items</NavLink>
                        </li>

                        <li>
                            <NavLink to="/d-goods">Goods</NavLink>
                        </li>
                    </>
                ) : (
                    <div />
                )}
            </ul>
        </Box>
    );

    return (
        <>
            <Box>
                <AppBar component={'nav'}>
                    <Toolbar sx={{ justifyContent: 'space-between' }}>
                        <IconButton
                            onClick={handleDrawerToggle}
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            sx={{ mr: 2, display: { sm: 'none' } }}
                        >
                            <MenuIcon />
                        </IconButton>

                        <Box sx={{ display: 'flex' }}>
                            <img src={KKLogo} alt="KK Foods Logo" style={{ height: 70, marginTop: 10, marginBottom: 10 }} />
                            <img
                                src={TitoLogo}
                                alt="KK Foods Logo"
                                style={{ height: 70, marginTop: 10, marginBottom: 10, marginLeft: 20 }}
                            />
                        </Box>

                        <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                            <ul className="navigaion-menu">
                                {user?.role === 'admin' || user?.role === 'super-admin' ? (
                                    <>
                                        <li>
                                            <NavLink activeClassName="active" to="/">
                                                Reps
                                            </NavLink>
                                        </li>

                                        <li>
                                            <NavLink to="/customers">Customers</NavLink>
                                        </li>

                                        <li>
                                            <NavLink to="/products">Products</NavLink>
                                        </li>

                                        <li>
                                            <NavLink to="/orders">Orders</NavLink>
                                        </li>

                                        <li>
                                            <NavLink to="/order-items">Order Items</NavLink>
                                        </li>

                                        <li>
                                            <NavLink to="/dispatched-items">Dispatched Items</NavLink>
                                        </li>

                                        <li>
                                            <NavLink to="/banks">Banks</NavLink>
                                        </li>

                                        <li>
                                            <NavLink to="/vendors">Vendors</NavLink>
                                        </li>

                                        <li>
                                            <NavLink to="/goods">Goods</NavLink>
                                        </li>

                                        <li>
                                            <NavLink to="/payments">Payments</NavLink>
                                        </li>
                                    </>
                                ) : user.role === 'account' ? (
                                    <>
                                        <li>
                                            <NavLink to="/a-banks">Banks</NavLink>
                                        </li>

                                        <li>
                                            <NavLink to="/a-vendors">Vendors</NavLink>
                                        </li>

                                        <li>
                                            <NavLink to="/a-payments">Payments</NavLink>
                                        </li>
                                    </>
                                ) : user.role === 'dispatch' ? (
                                    <>
                                        <li>
                                            <NavLink activeClassName="active" to="/d-reps">
                                                Reps
                                            </NavLink>
                                        </li>

                                        <li>
                                            <NavLink to="/d-customers">Customers</NavLink>
                                        </li>

                                        <li>
                                            <NavLink to="/d-products">Products</NavLink>
                                        </li>

                                        <li>
                                            <NavLink to="/d-orders">Orders</NavLink>
                                        </li>

                                        <li>
                                            <NavLink to="/d-order-items">Order Items</NavLink>
                                        </li>

                                        <li>
                                            <NavLink to="/d-dispatched-items">Dispatched Items</NavLink>
                                        </li>

                                        <li>
                                            <NavLink to="/d-goods">Goods</NavLink>
                                        </li>
                                    </>
                                ) : (
                                    <div />
                                )}
                            </ul>
                        </Box>
                        {/* {console.log(user)} */}

                        <Box>
                            <Tooltip title="Open settings">
                                <Button onClick={handleOpenUserMenu} variant="text" color="inherit">
                                    {user?.name}
                                </Button>
                            </Tooltip>

                            <Menu
                                sx={{ mt: '45px' }}
                                id="menu-appbar"
                                anchorEl={anchorElUser}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right'
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right'
                                }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                            >
                                <MenuItem onClick={handleCloseUserMenu}>
                                    <Typography textAlign="center">Profile</Typography>
                                </MenuItem>
                                <MenuItem onClick={handleLogout}>
                                    <Typography textAlign="center">Logout</Typography>
                                </MenuItem>
                            </Menu>
                        </Box>
                    </Toolbar>
                </AppBar>

                <Box component={'nav'}>
                    <Drawer
                        variant="temporary"
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        sx={{
                            display: { xs: 'block', sm: 'none' },
                            '& .MuiDrawer-paper': {
                                boxSizing: 'border-box',
                                width: '240px'
                            }
                        }}
                    >
                        {drawer}
                    </Drawer>
                </Box>
                <Box>
                    <Toolbar />
                </Box>
            </Box>
        </>
    );
};

export default memo(Header);
